import { render, staticRenderFns } from "./ServiceStatement.vue?vue&type=template&id=55a484d2&scoped=true"
import script from "./ServiceStatement.vue?vue&type=script&lang=js"
export * from "./ServiceStatement.vue?vue&type=script&lang=js"
import style0 from "./ServiceStatement.vue?vue&type=style&index=0&id=55a484d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a484d2",
  null
  
)

export default component.exports